import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { SignalrService } from 'src/app/Services/signalr.service';
import { WebinarRunService } from '../../Services/webinar-run.service';
import { User, WebinarRunClient, WebinarRunDTO } from '../../Services/WOWApi.Service';
import { CongratulationsPopupComponent, DynamicDialogConfig } from '../congratulations-popup/congratulations-popup.component';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { MatDialog } from '@angular/material/dialog';
import confetti from 'canvas-confetti';
import { CommonService } from 'src/app/Services/common.service';

@Component({
    selector: 'app-webinar-run',
    templateUrl: './webinar-run.component.html',
    styleUrls: ['./webinar-run.component.css'],
    standalone: false
})
export class WebinarRunComponent implements OnInit, OnDestroy {
  webinarGuid: string;
  showSpinner: boolean = false;
  selectedSeat:string;
  subscription: Subscription;
  webinarRunDTO:WebinarRunDTO;
  currentStatus:string = '';
  APITime:Date;
  displaySeats:boolean= false;
  countdownRemaining = Number.POSITIVE_INFINITY;
  /** True once we have been in DisplaySeats this session — used to gate the draw panel until the seat intro finishes. */
  private didEnterDisplaySeatsPhase = false;
  /** Set when user-seat finishes intro scroll (or there was nothing to scroll). Reset when entering DisplaySeats. */
  seatIntroScrollDone = false;
  /** True once the draw panel has announced the winner; gates the seat grid highlight. */
  private winnerRevealed = false;
  private confettiHandle: ReturnType<typeof setInterval> | null = null;
  private statusPollHandle: ReturnType<typeof setInterval> | null = null;
  private lastStatusRefreshMs = 0;
  private _alive:boolean = true;
  /** Video Playing is when phone browsers drop the hub; poll until we leave it. */
  private static readonly VIDEO_STATUS_POLL_MS = 3000;
  private static readonly STATUS_REFRESH_DEBOUNCE_MS = 800;
  loggedUser: User;
  isMobileView = false;
  constructor(private webinarRunClient:WebinarRunClient,
    private activatedRoute: ActivatedRoute,
    public webinarRunService:WebinarRunService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    public signalrService:SignalrService,
    private customServices:CustomServiceService,
    private commonService: CommonService
    ) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
   // this.showSpinner = true;
  //  this.APITime = new Date();
     this.webinarGuid = this.activatedRoute.snapshot.params.webinarguid;
     this.loggedUser = this.customServices.GetLoggedInUser();
  //    this.LoadData(this.webinarGuid)
    // this.webinarRunService.startConnection();
    // this.webinarRunService.GetData();        
    // this.startHttpRequest();
    //  this.subscription =  interval(10000).subscribe(value => this.LoadData(this.webinarGuid));
    this.signalrService.initiateSignalrConnection(this.loggedUser.id.toString(),this.webinarGuid);
    this.GetLatestStatus();
  }
   
  GetLatestStatus():void
  {
    this.webinarRunService
    .GetLatestRun(this.loggedUser.id.toString(), this.webinarGuid)
    .pipe(takeWhile(() => this._alive))
    .subscribe((data:WebinarRunDTO) => 
       this.onRunLoadSuccess(data,true)
    );
      
  }

  onRunLoadSuccess(data:WebinarRunDTO , isFirstCall =false)
  {   
    this.LoadUI(data);
    if(isFirstCall)
    {
      this.getRealTimeData();
    }
  }
  getRealTimeData()
  {
    this.webinarRunService.GetRealTimeData()
    .pipe(takeWhile(() => this._alive))
    .subscribe((data:WebinarRunDTO) => 
       this.onRunLoadSuccess(data)
    ); 
  }
   
  public LoadUI(data:WebinarRunDTO)
  {
    console.log("LoadUI called : ")
    console.log(JSON.stringify(data, null, 2));
    console.log("LoadUI ended");
        if(data == null)
       return false;
    this.APITime = new Date();

    // Always apply the latest DTO so realtime fields (dummy min/max, selected seat, seats list) refresh
    // even when the status string repeats.
    this.webinarRunDTO = data;

    if(this.currentStatus === data.status) {
       return false;
    }

      this.currentStatus = data.status;
    if(data.status == "DisplaySeats")
    {
      this.didEnterDisplaySeatsPhase = true;
      this.seatIntroScrollDone = !data.userSeats?.length;
    }
    let statusNames = [ "DisplaySeats" , "First Dummy Run", "Second Dummy Run", "Third Dummy Run", "Final Run", "Completed" ] 
    if(statusNames.indexOf(data.status) != -1)
    {
      console.log("X Display Seats : " + data.status);
      this.displaySeats = true;
    }
    this.syncVideoStatusPoll();

  }

  /**
   * Phone browsers freeze JS / drop the WebSocket while the webinar video plays
   * (especially once iOS takes over fullscreen). The Azure Function still
   * advances to DisplaySeats; this poll and the wake-up refetch are how the
   * page catches that push that never arrived.
   */
  onVideoPlaybackCaughtUp(): void {
    this.signalrService.ensureConnected();
    this.refreshStatusFromApi();
  }

  @HostListener('document:visibilitychange')
  onVisibility(): void {
    if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
      this.onVideoPlaybackCaughtUp();
    }
  }

  @HostListener('window:pageshow')
  onPageShow(): void {
    this.onVideoPlaybackCaughtUp();
  }

  @HostListener('window:focus')
  onWindowFocus(): void {
    this.onVideoPlaybackCaughtUp();
  }

  private refreshStatusFromApi(): void {
    if (!this._alive || !this.webinarGuid || !this.loggedUser) {
      return;
    }
    const now = Date.now();
    if (now - this.lastStatusRefreshMs < WebinarRunComponent.STATUS_REFRESH_DEBOUNCE_MS) {
      return;
    }
    this.lastStatusRefreshMs = now;
    this.webinarRunService
      .GetLatestRun(this.loggedUser.id.toString(), this.webinarGuid)
      .pipe(takeWhile(() => this._alive))
      .subscribe((data: WebinarRunDTO) => this.LoadUI(data));
  }

  private syncVideoStatusPoll(): void {
    const watchingVideo = this.webinarRunDTO?.status === 'Video Playing';
    if (watchingVideo && this.statusPollHandle == null) {
      this.statusPollHandle = setInterval(
        () => this.refreshStatusFromApi(),
        WebinarRunComponent.VIDEO_STATUS_POLL_MS
      );
      return;
    }
    if (!watchingVideo) {
      this.clearVideoStatusPoll();
    }
  }

  private clearVideoStatusPoll(): void {
    if (this.statusPollHandle != null) {
      clearInterval(this.statusPollHandle);
      this.statusPollHandle = null;
    }
  }

  /** Show draw/results only after DisplaySeats intro scroll completes (or user never hit that phase). */
  shouldShowResultsPanel(): boolean {
    if (!this.webinarRunDTO || !this.displaySeats) {
      return false;
    }
    const s = this.webinarRunDTO.status;
    if (s === "DisplaySeats") {
      return false;
    }
    if (!this.didEnterDisplaySeatsPhase) {
      return true;
    }
    return this.seatIntroScrollDone;
  }

  onSeatIntroScrollComplete(): void {
    this.seatIntroScrollDone = true;
  }

  get runVideoUrl(): string {
    const v = this.webinarRunDTO?.video;
    return typeof v === 'string' && v.trim() ? v.trim() : '';
  }

  get isCountdownPhase(): boolean {
    const s = this.webinarRunDTO?.status;
    return s === 'Not Started' || s === 'Started';
  }

  get isVideoPlayingPhase(): boolean {
    return this.webinarRunDTO?.status === 'Video Playing';
  }

  get keepRunPlayer(): boolean {
    if (!this.runVideoUrl) {
      return false;
    }
    if (this.isVideoPlayingPhase) {
      return true;
    }
    return this.isCountdownPhase && this.countdownRemaining <= 45;
  }

  /**
   * Seat number the grid should mark as drawn, or 0 for none.
   *
   * Only the official draw resolves to a seat. Calibration rounds put a machine number
   * in the same `selectedSeat` field, and when one happened to fall inside the real seat
   * range the grid lit up a live seat mid-calibration - viewers then believed they had won.
   *
   * The official draw sends the winner as a seat *id*, so it has to be mapped back to a
   * seat number; comparing an id against seat numbers highlighted the wrong seat.
   */
  get winnerSeatNumber(): number {
    const dto = this.webinarRunDTO;
    if (!dto || ['Final Run', 'Closed', 'Completed'].indexOf(dto.status) === -1) {
      return 0;
    }
    // Hold the grid highlight until the draw panel has announced the winner, so the
    // seat does not light up while the number is still rolling. A viewer who arrives
    // after the run is already Completed has nothing left to spoil.
    if (dto.status !== 'Completed' && !this.winnerRevealed) {
      return 0;
    }
    const selected = Number(dto.selectedSeat);
    if (!Number.isFinite(selected) || selected <= 0) {
      return 0;
    }
    const seats = dto.userSeats || [];
    const match = seats.find(s => s.seatId === selected) || seats.find(s => s.seatNumber === selected);
    return match ? match.seatNumber : 0;
  }

public LoadData(webinarGuid)
{
  this.webinarRunClient.getWebinarRun(webinarGuid).subscribe(x => {
    this.LoadUI(x);
  });
}
ngOnDestroy() {
  
  this.subscription && this.subscription.unsubscribe();
  this.clearConfetti();
  this.clearVideoStatusPoll();
  this._alive = false;
}

blastParty() {
  const duration = 15 * 1000;
  const animationEnd = Date.now() + duration;
  // The app raises .cdk-overlay-container to 10500, so the confetti has to clear that
  // to rain in front of the winner card. canvas-confetti keeps it pointer-events: none.
  const zIndex = 10600;
  const colors = ['#ffce1b', '#ff9d2e', '#ffffff', '#c41e3a', '#8b7cff'];
  const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

  // Opening volley from the bottom corners, then a slow drift from the top.
  confetti({ particleCount: 140, angle: 60, spread: 70, startVelocity: 55, origin: { x: 0, y: 1 }, colors, zIndex });
  confetti({ particleCount: 140, angle: 120, spread: 70, startVelocity: 55, origin: { x: 1, y: 1 }, colors, zIndex });

  const defaults = { startVelocity: 30, spread: 360, ticks: 60, colors, zIndex };
  this.clearConfetti();
  this.confettiHandle = setInterval(() => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) {
      this.clearConfetti();
      return;
    }
    const particleCount = 50 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
  }, 250);
}

private clearConfetti(): void {
  if (this.confettiHandle != null) {
    clearInterval(this.confettiHandle);
    this.confettiHandle = null;
  }
}

OpenCongratsPopup(info:DynamicDialogConfig)
{
  this.winnerRevealed = true;
  this.selectedSeat = info.SeatNumber.toString();

  // Scroll the winning seat into view before the popup overlays the page,
  // so the user actually sees which seat won.
  this.scrollToWinnerSeat(this.selectedSeat);

  // Give the smooth scroll a moment to land before the dialog covers the seat.
  setTimeout(() => {
    const dialogRef = this.dialog.open(CongratulationsPopupComponent, {
      width: '600px',
      data: info,
      panelClass: 'winner-dialog-panel',
      backdropClass: 'winner-dialog-backdrop'
    });
    this.blastParty();
  }, 1200);
}

private scrollToWinnerSeat(seatNumber: string): void {
  if (!seatNumber) {
    return;
  }
  // Defer to next tick so Angular has applied the `selected` class binding
  // before we measure / scroll.
  setTimeout(() => {
    const winnerEl = document.getElementById('seat' + seatNumber);
    if (winnerEl) {
      winnerEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }, 0);
}

  // private startHttpRequest = () => {
  //    this.webinarRunClient.getWebinarRun(this.webinarGuid).subscribe(res => {
  //     this.webinarRunService.webinarRunDTO = res;
  //     if(res.status == "Not Started")
  //       {
  //         var startDate = new Date();
  //         var seconds = (  res.currentDateTime.getTime()-res.webinarStartDateTime.getTime()) / 1000;
  //         this.counter = seconds;
  //        this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
  //       }
  //   });
  // }

}
